<template>
  <section class="section">
    <div class="container">
      <h3 class="subtitle green has-text-weight-bold">
        {{ $translate('attach') }}
      </h3>
      <div class="columns">
        <div v-for="side in sides" :key="side" class="column is-6">
          <div class="card">
            <div class="columns is-vcentered">
              <div class="column has-text-centered">
                <b-button
                  inverted
                  icon-left="scanner"
                  :disabled="disabledbool || sideDisabled(side)"
                  :class="[order.attachment[`scan_fms_${side}`] != null ? 'is-uploaded' : 'is-primary']"
                  @click="openFmsModal(side)"
                >
                  <span>{{ $translate('duna') }}</span>
                </b-button>
              </div>
              <div v-for="entry in simpleEntries" :key="`${entry.key}_${side}`" class="column has-text-centered">
                <b-button
                  inverted
                  :icon-left="entry.icon"
                  :disabled="disabledbool || sideDisabled(side)"
                  :class="[order.attachment[`${entry.key}_${side}`] != null ? 'is-uploaded' : 'is-primary']"
                  @click="openModal(entry.key, side)"
                >
                  <span>{{ $translate(entry.labelKey) }}</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="green" />

      <h3 class="subtitle green has-text-centered">
        {{ $translate('patient_title') | uppercase }}
      </h3>

      <div class="columns is-centered">
        <div class="column is-4 has-text-centered">
          <b-field
            :label="$translate('pat_weight') | capitalize"
            :type="{ 'is-danger': errors.has('pat_weight') }"
            :message="errors.first('pat_weight')"
          >
            <b-input
              v-validate="'between:0,999|integer'"
              :value="order.footmeasurements.pat_weight"
              name="pat_weight"
              type="number"
              :placeholder="$translate('weight_placeholder')"
              :disabled="disabledbool"
              :use-html5-validation="false"
              @input="val => onSingleChange('pat_weight', val)"
            />
          </b-field>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-narrow">
          <table class="bordered-table dynamic">
            <tbody>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('size_sx') }" :message="errors.first('size_sx')">
                    <b-input
                      v-validate="sizeValidation('sx')"
                      :value="order.footmeasurements.size_sx"
                      name="size_sx"
                      type="number"
                      :placeholder="$translate('placeholder_foot_size')"
                      :disabled="disabledbool || sideDisabled('sx')"
                      :use-html5-validation="false"
                      @input="val => onSingleChange('size_sx', val)"
                    />
                  </b-field>
                </td>
                <td class="header">
                  <strong>{{ $translate('size') | capitalize }}</strong>
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('size_dx') }" :message="errors.first('size_dx')">
                    <b-input
                      v-validate="sizeValidation('dx')"
                      :value="order.footmeasurements.size_dx"
                      name="size_dx"
                      type="number"
                      :placeholder="$translate('placeholder_foot_size')"
                      :disabled="disabledbool || sideDisabled('dx')"
                      :use-html5-validation="false"
                      @input="val => onSingleChange('size_dx', val)"
                    />
                  </b-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <MeasurementsInsole :order.sync="order" :disabledbool="disabledbool" :table-fields="patientFields" />

      <hr class="green" />

      <h3 class="subtitle green has-text-centered">
        {{ $translate('insole_thicknesses') | uppercase }}
      </h3>

      <MeasurementsInsole :order.sync="order" :disabledbool="disabledbool" :table-fields="thicknessFields" />

      <template v-if="$moduleConfiguration[order.module].orderHasMeasurementsNotes">
        <hr class="green" />

        <h3 class="subtitle green">
          {{ $translate('insole_notes') | uppercase }}
        </h3>
        <b-field>
          <b-input
            v-model="order.footmeasurements.notes"
            :disabled="disabledbool"
            type="textarea"
            name="measurements_notes"
            :placeholder="$translate('placeholder_insole_notes')"
          >
          </b-input>
        </b-field>
      </template>

      <b-modal
        v-for="side in sides"
        :key="`fms_${side}_modal`"
        :active.sync="modals[`fms_${side}`]"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-modal
      >
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $translate('scan') }}</p>
          </header>
          <section class="modal-card-body">
            <div v-if="order.attachmentflag[`scan_fms_${side}`] == 1">
              <b-button class="is-danger" :disabled="disabledbool" @click="removedFile(`scan_fms_${side}`)">
                {{ $translate('remove_scan') }}
              </b-button>
              <a target="_blank" :href="order.attachment[`scan_fms_${side}`]">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_fms') }}
                </b-button>
              </a>
            </div>
            <template v-else>
              <b-field class="file">
                <b-upload
                  v-model="order.attachment[`scan_fms_${side}`]"
                  :name="`scan_fms_${side}`"
                  accept=".fms"
                  drag-drop
                  :disabled="disabledbool"
                  @input="file => onFmsUpload(side, file)"
                >
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon icon="upload" size="is-large" />
                      </p>
                      <p>{{ $translate('dummy_text_drop_scan_fms') }}</p>
                    </div>
                  </section>
                </b-upload>
              </b-field>
              <div v-if="order.attachment[`scan_fms_${side}`]" class="tags">
                <span class="tag is-primary">
                  {{ order.attachment[`scan_fms_${side}`].name }}
                  <button class="delete is-small" type="button" @click="removedFile(`scan_fms_${side}`)" />
                </span>
              </div>
            </template>
            <table class="fms-preview">
              <tr v-for="field in patientFields" :key="`fms-${field.key}-${side}`">
                <td style="text-align: center; vertical-align: middle; width: 50%">
                  <strong>{{ $translate(field.key) | capitalize }}</strong>
                </td>
                <td style="text-align: center; vertical-align: middle; width: 50%">
                  <b-field>
                    <b-input
                      v-model="tempfms[side][field.key]"
                      type="number"
                      :disabled="true"
                      :placeholder="$translate('placeholder_measure_mm')"
                      step="1"
                    />
                  </b-field>
                </td>
              </tr>
            </table>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="modals[`fms_${side}`] = false">
              {{ $translate('exit_without_saving') }}
            </button>
            <button
              class="button"
              type="button"
              :disabled="disabledbool"
              @click="
                importFmsFromTemp(side)
                modals[`fms_${side}`] = false
              "
            >
              {{ $translate('exit_and_saving') }}
            </button>
          </footer>
        </div>
      </b-modal>

      <template v-for="side in sides">
        <b-modal
          v-for="entry in simpleEntries"
          :key="`${entry.key}_${side}_modal`"
          :active.sync="modals[`${entry.key}_${side}`]"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
        >
          <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
              <p class="modal-card-title">{{ $translate(entry.labelKey) }}</p>
            </header>
            <section class="modal-card-body">
              <b-field :label="$translate(entry.labelKey) | capitalize">
                <b-field v-if="order.attachmentflag[`${entry.key}_${side}`] != 1" class="file">
                  <b-upload
                    v-model="order.attachment[`${entry.key}_${side}`]"
                    :name="`${entry.key}_${side}`"
                    :accept="entry.accept"
                    :disabled="disabledbool"
                    @input="() => onUpload(entry.key, side)"
                  >
                    <a class="button is-primary" :disabled="disabledbool">
                      <b-icon icon="upload" />
                      <span>{{ $translate('upload_button') }}</span>
                    </a>
                  </b-upload>
                  <span v-if="order.attachment[`${entry.key}_${side}`]" class="file-name">
                    {{ order.attachment[`${entry.key}_${side}`].name }}
                  </span>
                  <b-button
                    :disabled="!order.attachment[`${entry.key}_${side}`] || disabledbool"
                    icon-left="minus"
                    class="is-danger"
                    @click="removedFile(`${entry.key}_${side}`)"
                  >
                    {{ $translate('remove_file') }}
                  </b-button>
                </b-field>
                <div v-else>
                  <a target="_blank" :href="order.attachment[`${entry.key}_${side}`]">
                    <b-button icon-left="file">{{ $translate('link_to_file') }}</b-button>
                  </a>
                  <br />
                  <b-button
                    :disabled="disabledbool"
                    icon-left="minus"
                    class="is-danger"
                    @click="removedFile(`${entry.key}_${side}`)"
                  >
                    {{ $translate('remove_file') }}
                  </b-button>
                </div>
              </b-field>
            </section>
            <footer class="modal-card-foot">
              <button class="button" type="button" @click="modals[`${entry.key}_${side}`] = false">
                {{ $translate('close') }}
              </button>
            </footer>
          </div>
        </b-modal>
      </template>
    </div>
  </section>
</template>

<script>
import MeasurementsInsole from './MeasurementsInsole.vue'

export default {
  name: 'MeasurementsInsoleForm',
  components: { MeasurementsInsole },
  props: ['order', 'disabledbool', 'missingattachment', 'arraytodelete'],
  inject: ['$validator'],
  data() {
    return {
      sides: ['sx', 'dx'],
      modals: {},
      tempfms: {
        sx: { length: null, width: null, crimp: null },
        dx: { length: null, width: null, crimp: null },
      },
      simpleEntries: [
        { key: 'scan_stl', labelKey: 'scan', accept: '.stl', icon: 'scanner' },
        { key: 'grap', labelKey: 'grap', accept: 'image/*', icon: 'fingerprint' },
        { key: 'attach', labelKey: 'attach', icon: 'paperclip' },
      ],
      patientFields: [{ key: 'length' }, { key: 'width' }, { key: 'crimp' }],
      thicknessFields: [
        { key: 'ball_height', min: 0, max: 200, required: true },
        { key: 'fings_height', min: 0, max: 200, required: true },
        { key: 'heel_height', min: 0, max: 200, required: true },
        { key: 'sup_col_med', min: 0, max: 200, required: true },
        { key: 'avvolgenza_mediale', min: 0, max: 200, required: true },
      ],
    }
  },
  methods: {
    sideDisabled(side) {
      return side === 'sx' ? this.order.pair === 'right' : this.order.pair === 'left'
    },
    sizeValidation(side) {
      const sideMod = side === 'sx' ? this.order.mod_sx : this.order.mod_dx
      const candidates = [sideMod, this.order.mod]
        .filter(mod => mod && mod.sizes && mod.sizes.min != null && mod.sizes.max != null)
        .map(mod => mod.sizes)
      const rules = []
      if (!this.disabledbool && !this.sideDisabled(side)) {
        rules.push('required')
      }
      if (!candidates.length) {
        rules.push('between:0,999')
      } else {
        const min = Math.max(...candidates.map(sizes => sizes.min))
        const max = Math.min(...candidates.map(sizes => sizes.max))
        rules.push(`between:${min},${max}`)
      }
      rules.push('integer')
      return rules.join('|')
    },
    openModal(entryKey, side) {
      this.$set(this.modals, `${entryKey}_${side}`, true)
    },
    openFmsModal(side) {
      this.patientFields.forEach(field => {
        this.tempfms[side][field.key] = this.order.footmeasurements[`${field.key}_${side}`]
      })
      this.$set(this.modals, `fms_${side}`, true)
    },
    onSingleChange(key, val) {
      this.$set(this.order.footmeasurements, key, val)
    },
    onUpload(key, side) {
      this.$set(this.order.attachmentflag, `${key}_${side}`, 0)
    },
    onFmsUpload(side, file) {
      this.$set(this.order.attachmentflag, `scan_fms_${side}`, 0)
      if (file && file.name) {
        const reader = new FileReader()
        reader.onload = e => this.parseFms(e.target.result, side)
        reader.readAsText(file)
      }
    },
    parseFms(content, side) {
      const EOL = '\n'
      const map = [{ key: 'length', tag: 'Fl=' }, { key: 'width', tag: 'Fw=' }, { key: 'crimp', tag: 'Pl_HeelHeight=' }]
      map.forEach(m => {
        const pos = content.indexOf(m.tag)
        if (pos === -1) return
        const value = Math.ceil(content.substring(pos + m.tag.length, content.indexOf(EOL, pos) - 1)).toString()
        this.tempfms[side][m.key] = value
      })
    },
    importFmsFromTemp(side) {
      this.patientFields.forEach(field => {
        const value = this.tempfms[side][field.key]
        if (value != null) {
          this.$set(this.order.footmeasurements, `${field.key}_${side}`, value)
        }
      })
    },
    removedFile(item) {
      if (this.order.attachmentflag[item] === 1) {
        this.arraytodelete[item] = this.order.attachment[item]
      }
      this.$set(this.order.attachment, item, null)
      this.$set(this.order.attachmentflag, item, 0)
    },
    checkValue() {
      if (this.order.footmeasurements.size != null) {
        if (this.order.footmeasurements.size_sx == null) {
          this.$set(this.order.footmeasurements, 'size_sx', this.order.footmeasurements.size)
        }
        if (this.order.footmeasurements.size_dx == null) {
          this.$set(this.order.footmeasurements, 'size_dx', this.order.footmeasurements.size)
        }
      }
      this.$delete(this.order.footmeasurements, 'size')
      const sided = [
        'length',
        'width',
        'crimp',
        'ball_height',
        'fings_height',
        'heel_height',
        'sup_col_med',
        'avvolgenza_mediale',
        'size',
      ]
      const keys = []
      sided.forEach(k => keys.push(`${k}_sx`, `${k}_dx`))
      keys.push('pat_weight', 'notes')
      keys.forEach(k => {
        if (this.order.footmeasurements[k] === undefined) {
          this.$set(this.order.footmeasurements, k, null)
        }
      })
      const attachmentKeys = ['scan_fms', 'scan_stl', 'grap', 'attach']
      attachmentKeys.forEach(key => {
        this.sides.forEach(side => {
          const ak = `${key}_${side}`
          if (this.order.attachment[ak] === undefined) this.$set(this.order.attachment, ak, null)
          if (this.order.attachmentflag[ak] === undefined) this.$set(this.order.attachmentflag, ak, 0)
        })
      })
    },
  },
}
</script>
<style scoped>
.container >>> .is-uploaded {
  background-color: #008a6b;
  color: white;
}
.fms-preview {
  width: 100%;
  margin-top: 1rem;
}
.fms-preview td {
  padding: 5px;
}
</style>
